import {
  ModalType,
  useFeatureFlagContext,
  useModalContext,
} from 'modules/campaigns/editor/context';
import { useSendTimeExperiment } from 'modules/campaigns/editor/hooks';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { TimeClock24 } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const ScheduleCampaignAction = () => {
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { openModal } = useModalContext();
  const { hasSendTimeExperiment } = useSendTimeExperiment();

  return (
    <CampaignPermissionCheck
      action={'schedule'}
      ChildWrapper={CampaignPopover}
      additionalCheck={hasSendTimeExperiment}
      additionalCheckTooltip={'This campaign has send time experiments. It cannot be scheduled.'}
    >
      <PrimaryButton
        data-test="schedule-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.ScheduleCampaign)}
        isDisabled={hasSendTimeExperiment || isSuspendSendsEnabled}
      >
        <TimeClock24 />
        Schedule
      </PrimaryButton>
    </CampaignPermissionCheck>
  );
};
